module.exports = __webpack_public_path__ + "img/image.5d1b4902.png";